export default __webpack_public_path__ + "static/media/white-theme-park-carosuel-rollercoaster.741247cd.png";